'use strict';

export default angular.module('contartemx.organizacion', [
  'ui.router'
])
  .config([
    '$stateProvider', ($stateProvider) => {

      $stateProvider.state('organizacion', {
        url: '/Despacho',
        abstract: true,
        views: {
          'submenu': {
            template: require('../../../../app/views/Organizacion/Organizacion_submenu.html'),
          },
          '': {
            template: require(`../../../../app/views/MainContainer.html`)
          }
        },
        resolve: {
          authorize: ['authorization', authorization => authorization.authorize()],
          contartemxOrganizacion: ($q, $ocLazyLoad) => {
            return import(
              /* webpackChunkName: "organizacion" */
              './organizacion'
            ).then(module => $ocLazyLoad.inject(module.default));
          }
        }
      })
        .state('organizacion.timbres', {
          url: '/Timbres',
          views:
          {
            'main': {
              template: require(`../../../../app/views/Organizacion/Timbres/Timbres_main.html`),
              controller: 'TimbresOrgCtrl'
            }
          },
        })
        .state('organizacion.colaboradores', {
          url: '/Usuarios',
          views:
          {
            'main': {
              template: require(`../../../../app/views/Organizacion/Colaboradores/Colaboradores_main.html`),
              controller: 'ColaboradoresCtrl'
            }
          }
        })
        .state('organizacion.suscripcion', {
          url: '/Suscripcion',
          views:
          {
            'main': {
              template: require(`../../../../app/views/Organizacion/Membresia/Membresia_main.html`),
              controller: 'MembresiaCtrl'
            }
          }
        })
        .state('organizacion.perfil', {
          url: '/Perfil',
          views:
          {
            'main': {
              template: require(`../../../../app/views/Organizacion/Perfil/Perfil_main.html`),
              controller: 'PerfilCtrl'
            }
          }
        });
    }
  ]);
